import React, { useState } from 'react';
import { bool, string, object } from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

import defaultClasses from './BobTableContextMenu.module.css';

const BobTableContextMenu = ({
    activeTab,
    createNewRequest,
    configurationData,
    entityData,
    handleEditUser,
    hidden,
    hideSubscribe,
    handleCloneRole,
    handleEnableOrDisable,
    handleRuleBuilderMenu,
    handleShowDebuggerMessage,
    handleConfigurationMenu,
    isEditable = true,
    isEnabledCompany,
    isRuntimeCalculation,
    isViewOwner,
    onDelete,
    onFetch,
    onPreviewSensorData,
    onPreviewWeatherData,
    onResetCalculation,
    onResetCalculationModal,
    onSubscribeAlerts,
    type,
    formula,
    currentUser,
    handleResetPassword,
    ruleData,
    setSelectedRule,
    setSelectedRole,
    userData,
    loadFormula,
    isFullRuleAllowed,
    props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        if (type === 'Formula' || type === 'Template' || type === 'K2AFormula' || type === 'K2ATemplate') {
            if (loadFormula) {
                loadFormula(formula);
            }
        }
     
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function onDeleteEntity() {
        onDelete(entityData);
        handleClose();
    }

    function onSubscribeToAlerts() {
        onSubscribeAlerts(entityData);
        handleClose();
    }

    function onSensorDataPreview() {
        onPreviewSensorData(entityData);
        handleClose();
    }

    const onCalculationReset = () => {
        onResetCalculation(entityData);
        handleClose();
    };

    const onEditEntity = () => {
        onFetch(entityData);
        handleClose();
    };

    const onReportPreview = () => {
        onFetch(entityData,'select');
        handleClose();
    };

    const onReportDelete = () => {
        onFetch(entityData,'delete');
        handleClose();
    };

    const onAnnouncementSelect = () => {
        onFetch(entityData,'select');
        handleClose();
    };
    
    /*  const onAnnouncementPublish = ()=> {
        onFetch(entityData,'publish');
        handleClose();
    };
    */
    
    const onAnnouncementDelete = ()=> {
        onFetch(entityData,'delete');
        handleClose();
    };
    
    const onAnnouncementActive = ()=> {
        onFetch(entityData,'active');
        handleClose();
    };
      
    const onAnnouncementClone = ()=> {
        onFetch(entityData,'clone');
        handleClose();
    };

    // const onAnnouncementInActive = ()=> {
    //     onFetch(entityData,'inactive');
    //     handleClose();
    // };

    const handleRoleAction = (type) => {
        if ( type === 'Edit') {
            setSelectedRole(entityData);
        } else if (type === 'Clone') {
            handleCloneRole(entityData);
        }
        handleClose();
    };
    
    const serviceRequestAction = (type) => {
        onFetch(entityData, type);
        handleClose();
    };

    const closeFormula = (type) => {
        onFetch( type );
        handleClose();
    };

    const onCreateServiceRequest = (type) => {
        createNewRequest(entityData, type);
        handleClose();
    };

    const selectedRule = () =>{
        setSelectedRule(ruleData);
    };

    const onShowDebuggerMessage = () => {
        handleShowDebuggerMessage(entityData);
    };

    const onRuleBuilderMenuClick = (type) => {
        handleRuleBuilderMenu(ruleData, type);
    };

    const onConfigurationMenuClick = (type) => {
        handleConfigurationMenu(configurationData, type);
    };
    
    const handleResetPasswordClick = () => {
        handleResetPassword(userData);
        handleClose();
    };

    const handleEditUserClick = () => {
        handleEditUser(userData);
        handleClose();
    };

    function resetCalculationClick() {
        onResetCalculationModal(entityData);
        handleClose();
    }

    const renderMenu = () => {
        if (type === 'Roles') {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handleRoleAction('Edit')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handleRoleAction('Clone')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        content_copy
                    </span>
                    Clone Role
                </MenuItem>
            </Menu>;
        } else if (type === 'ServiceManagement') {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => serviceRequestAction('Approve')}
                >
                    <i className="fas fa-check" />
                    Approve
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => serviceRequestAction('Decline')}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Decline
                </MenuItem>
            </Menu>;
        } else if (type === 'CalculatedSensors') {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                {onPreviewSensorData ?
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onSensorDataPreview}
                    >
                        <span className="material-icons-outlined material-icon-size">preview</span>
                        Preview Data
                    </MenuItem>
                    : null
                }
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onEditEntity}
                >
                    <i className="fas fa-edit" />
                    Edit
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onDeleteEntity}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete
                </MenuItem>
                {
                    isRuntimeCalculation ? 
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={resetCalculationClick}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                restart_alt
                            </span>
                            Reset Calculation
                        </MenuItem> : null
                }
                {
                    isRuntimeCalculation ? 
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onCalculationReset}
                        >
                            <span className="material-icons-outlined material-icon-size">restart_alt</span>
                            Reset
                        </MenuItem>
                        : null
                }
            </Menu>;
        } 
        else if ( type === 'BackgroundJobs' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        left:      '50%',
                        transform: 'translateX(-65%) translateY(30%)'
                    }
                }}
                // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onAnnouncementDelete}
                >
                    <i className="fas fa-trash-alt" />
                    Delete
                </MenuItem>
            </Menu>;
        }
        else if ( type === 'Reporting' ) {
           
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        left:      '50%',
                        transform: 'translateX(-65%) translateY(30%)'
                    }
                }}
                // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onReportPreview}
                >
                 
                    <React.Fragment>
                        <i style={{fontSize: 13}} className="fas fa-bullseye" />
                        Preview
                    </React.Fragment>                       
                           
                </MenuItem>
               
               
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onReportDelete}
                >
                    <i className="fas fa-trash-alt" />
                    Delete
                </MenuItem>
            </Menu>;
           
        }
        else if ( type === 'Announcements' ) {
            if (entityData.status === 'Draft') {
                return <Menu
                    id="render-props-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            left:      '50%',
                            transform: 'translateX(-65%) translateY(30%)'
                        }
                    }}
                // eslint-disable-next-line react/jsx-closing-bracket-location
                >
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onAnnouncementSelect}
                    >
                        {currentUser.isSuperUser ?
                            <React.Fragment>
                                <i className="fas fa-edit" />
                                Edit
                            </React.Fragment>
                            : <React.Fragment>
                                <i style={{fontSize: 13}} className="fas fa-bullseye" />
                                View
                            </React.Fragment>}
                       
                           
                    </MenuItem>
                    {currentUser.isSuperUser ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onAnnouncementClone}
                        >
                            <React.Fragment>
                                <i className="fas fa-clone" />
                                Clone
                            </React.Fragment>
                        </MenuItem>
                        :''
                    }
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onAnnouncementActive}
                    >
                        <i className="fas fa-file-import" />
                        Publish
                    </MenuItem>
               
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onAnnouncementDelete}
                    >
                        <i className="fas fa-trash-alt" />
                        Delete
                    </MenuItem>
                </Menu>;
            }
            else if (entityData.status === 'Inactive')  {
                return <Menu
                    id="render-props-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            left:      '50%',
                            transform: 'translateX(-73%) translateY(31%)'
                        }
                    }}
                // eslint-disable-next-line react/jsx-closing-bracket-location
                >
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onAnnouncementSelect}
                    >
                        <i style={{fontSize: 13}} className="fas fa-bullseye" />
                        View
                    </MenuItem>
                    {currentUser.isSuperUser ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onAnnouncementClone}
                        >
                            <React.Fragment>
                                <i className="fas fa-clone" />
                                Clone
                            </React.Fragment>
                        </MenuItem>
                        :''
                    }
                </Menu>;
            }
            else if (entityData.status === 'Active')  {
                return <Menu
                    id="render-props-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            left:      '50%',
                            transform: 'translateX(-73%) translateY(31%)'
                        }
                    }}
                // eslint-disable-next-line react/jsx-closing-bracket-location
                >
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onAnnouncementSelect}
                    >
                        {currentUser.isSuperUser ?
                            <React.Fragment>
                                <i className="fas fa-edit" />
                                Edit
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <i style={{fontSize: 13}} className="fas fa-bullseye" />
                                View
                            </React.Fragment>}
                    </MenuItem>
                    {currentUser.isSuperUser ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onAnnouncementClone}
                        >
                            <React.Fragment>
                                <i className="fas fa-clone" />
                                Clone
                            </React.Fragment>
                        </MenuItem>
                        :''
                    }
                    {/*currentUser.isSuperUser ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onAnnouncementInActive}
                        >
                            <i className="fas fa-file-export" />
                            Set as Inactive
                        </MenuItem> :''
                        */}
                </Menu>;
            }
        } else if ( type === 'CompanyManagement') {
            return (
                <Menu
                    id="render-props-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onEditEntity}
                    >
                        <i className="fas fa-edit" />
                        Edit
                    </MenuItem>
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={handleEnableOrDisable}
                    >
                        { isEnabledCompany ? 
                            <span className={`material-icons-outlined material-icon-size`}>
                                do_not_disturb_on
                            </span> 
                            : <span className={`material-icons-outlined material-icon-size`}>
                                check_circle
                            </span>}
                        { isEnabledCompany ? 'Disable' : 'Enable'}
                    </MenuItem>
                </Menu>);
        }
        else if ( type === 'Users' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleEditUserClick}
                >
                    <i className="fas fa-edit" />
                    Edit
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleResetPasswordClick}
                >
                    <i className="fa fa-link" />
                    Reset Password
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-minus-circle" />
                    Disable User
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Remove
                </MenuItem>
            </Menu>;
        } else if ( type === 'OpenRuleInfoModalFromFaultsPage' || type === 'OpenRuleInfoModalFromSystemRulesPage' || type === 'OpenRuleInfoModalFromEquipmentRulesPage' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={selectedRule}
                >
                    <span className="material-icons-outlined material-icon-size">
                        info
                    </span>
                    View More Info
                </MenuItem>
            </Menu>;
        } else if (type === 'RuleDebugger') {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => onShowDebuggerMessage('manage')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        text_snippet
                    </span>
                    View Message
                </MenuItem>
            </Menu>;
        } else if ( type === 'RuleList' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => onRuleBuilderMenuClick('manage')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        settings
                    </span>
                    Manage
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => onRuleBuilderMenuClick('debugger')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        bug_report
                    </span>
                    Debugger
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => onRuleBuilderMenuClick('viewTargets')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        mode_standby
                    </span>
                    View Targets
                </MenuItem>
                {isFullRuleAllowed ?
                    <React.Fragment>
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onRuleBuilderMenuClick('duplicate')}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                content_copy
                            </span>
                            Duplicate
                        </MenuItem>
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onRuleBuilderMenuClick('delete')}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                delete
                            </span>
                            Delete
                        </MenuItem>
                    </React.Fragment>
                    : null}
            </Menu>;
        } else if ( type === 'ConfigurationList' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                {
                    isEditable ? 
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onConfigurationMenuClick('saveAs')}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                save_as
                            </span>
                            Save As
                        </MenuItem>
                        : null
                }
                {
                    isViewOwner && isEditable? 
                
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onConfigurationMenuClick('edit')}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                edit
                            </span>
                            Edit
                        </MenuItem>
                        : null
                }
                {
                    isViewOwner ? 
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onConfigurationMenuClick('delete')}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                delete
                            </span>
                            Delete
                        </MenuItem>
                        : null
                }
            </Menu>;
        } 
        else if ( type === 'Formula' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => closeFormula('clone')}
                >
                    <React.Fragment>
                        <i className="fas fa-clone" />
                        Clone
                    </React.Fragment>
                </MenuItem>
                {currentUser.isSuperUser ?
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={() => closeFormula('delete')}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            delete
                        </span>
                        Deactivate
                    </MenuItem>
                    :''}
                {
                   
                
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={() => closeFormula('enable')}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            check_circle
                        </span>
                        Enable
                    </MenuItem>
                        
                }
                {
                   
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={() => closeFormula('disable')}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            do_not_disturb_on
                        </span>
                        Disable
                    </MenuItem>
                        
                }
            </Menu>;
        }
        else if ( type === 'K2AFormula' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
               
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => closeFormula('delete')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        delete
                    </span>
                    Deactivate
                </MenuItem>
                   
            </Menu>;
        }
        
        else if ( type === 'Template' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => closeFormula('clone')}
                >
                    <React.Fragment>
                        <i className="fas fa-clone" />
                        Clone
                    </React.Fragment>
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => closeFormula('delete')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        delete
                    </span>
                    Deactivate
                </MenuItem>
                {/*
                   
                
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={() => closeFormula('enable')}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            check_circle
                        </span>
                        Enable
                    </MenuItem>
                        
                    */}
                {/*
                   
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={() => closeFormula('disable')}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            do_not_disturb_on
                        </span>
                        Disable
                    </MenuItem>
                        
                    */}
            </Menu>;
        }
        else if ( type === 'K2ATemplate' ) {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => closeFormula('delete')}
                >
                    <span className="material-icons-outlined material-icon-size">
                        delete
                    </span>
                    Deactivate
                </MenuItem>
                
            </Menu>;
        }
        else {
            return <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                {onPreviewSensorData ?
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onSensorDataPreview}
                    >
                        <span className="material-icons-outlined material-icon-size">preview</span>
                        Preview Data
                    </MenuItem>
                    : null
                }
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onEditEntity}
                >
                    <i className="fas fa-edit" />
                    Edit
                </MenuItem>
                { hideSubscribe ?
                    null
                    :
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={onSubscribeToAlerts}
                    >
                        <i className="fas fa-bell" />
                        Subscribe to Alerts
                    </MenuItem>
                }
                { type && type === 'OpenRuleInfoModal' ?
                    <MenuItem
                        classes={{
                            root: defaultClasses.menuItem
                        }}
                        onClick={selectedRule}
                    >
                        <span className="material-icons-outlined material-icon-size">
                            info
                        </span>
                        View More Info
                    </MenuItem> : ''
                }
                {
                    type && type === 'site' ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={() => onPreviewWeatherData(entityData)}
                        >
                            <span className="material-icons-outlined material-icon-size">
                                info
                            </span>
                            Preview Weather Data
                        </MenuItem> : ''
                }
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={onDeleteEntity}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Deactivate
                </MenuItem>
                {
                    process.env.createServiceRequestEnabled && activeTab === 'CompanyEquipment' ?
                        <MenuItem
                            classes={{
                                root: defaultClasses.menuItem
                            }}
                            onClick={onCreateServiceRequest}
                        >
                            <i className={`fa fa-plus ${defaultClasses.menuItemIcon}`} aria-hidden="true" />
                            New Service Request
                        </MenuItem> : null
                }
            </Menu>;
        }
    };
    
    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                {type === 'Announcements' || type === 'BackgroundJobs' ?
                    <i className="fas fa-ellipsis-v" />:   <React.Fragment> {type === 'Reporting' && entityData.status.toLowerCase() !== 'complete' ? <CircularProgress color="inherit" size={15} /> :<i className="fas fa-ellipsis-h" /> } </React.Fragment>}
            </Button>
            { renderMenu() }
        </React.Fragment>
    );
};

BobTableContextMenu.defaultProps = {
    hidden:      false,
    currentUser: {}
};

BobTableContextMenu.propTypes = {
    hidden:      bool,
    location:    object,
    entity:      object,
    entityName:  string,
    currentUser: object

};

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(BobTableContextMenu);

